//export const BASE_URL = 'http://localhost:3000';
//export const API_URL = "http://localhost:10088/api";
//export const API_URL = 'https://ababe.node4.devplatform2.com/api'
export const API_URL = process.env.REACT_APP_API_URL;
